import ApplicationLoader from "@/containers";

import QuizContainer from "./QuizContainer";

const AppLoader = new ApplicationLoader(QuizContainer);

AppLoader.start();
